// export const getRole = () => {
//     return localStorage.getItem("role");
// };

// export const setRole = (role) => {
//     localStorage.setItem("role", role);
// };

// export const clearRole = () => {
//     localStorage.removeItem("role");
// };

// export const getUser = () => {
//     const user = localStorage.getItem("user");
//     return user ? JSON.parse(user) : null;
// };

// export const getUserId = () => {
//     const user = getUser();
//     return user?.id || null;
// };


export const getRole = () => {
    return localStorage.getItem("currentRole");
};

export const setRole = (role) => {
    localStorage.setItem("currentRole", role);
};

export const clearRole = () => {
    localStorage.removeItem("currentRole");
};

export const getUser = () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
};

export const getUserId = () => {
    const user = getUser();
    return user?.id || null;
};